import LinkObjectModal from './link-object-modal'
import {getFitRows} from "../../components/lnk-picklist";

class ObjectService {
	instances = []
	Vue;

	get instance() {
		for (let i = 0; i < this.instances.length; i++) {
			const ins = this.instances[i];
			if (!ins.show) return ins
		}
		const ins = this.newInstance()
		this.instances.push(ins)
		return ins
	}

	constructor(Vue) {
		this.Vue = Vue
	}

	newInstance() {
		const component = new Vue(LinkObjectModal);
		const instance = component.$mount()
		document.body.appendChild(instance.$el);
		return instance
	}

	async pick({option, onConfirm, onCancel, onComplete, dialog}) {
		option._loadDefaultOption('object-modal');

		/*自定义页面高度，自动计算显示行数*/
		if (option.showNum == null) {
			const fitRows = getFitRows()
			option.fillRows = fitRows[0]
			this.Vue.prototype.$set(option.param, 'rows', fitRows[0])
			if (!option.sizeOption) {
				option.sizeOption = fitRows
			} else {
				if (option.sizeOption.indexOf(option.fillRows) === -1) {
					option.sizeOption.unshift(option.fillRows)
				}
			}
		}

		const ins = this.instance;
		ins.option = null
		await ins.$lv.nextTick()
		Object.assign(ins, {option, onConfirm, onCancel, onComplete, dialog})
		await ins.$lv.nextTick()
		const table = option.getTable()
		if (!!table) table.clearSearchValue()
		await ins.$lv.nextTick()
		ins.show = true
		option.list.splice(0, option.list.length)
		option.reload()
	}
}

export default ObjectService;
